interface FaqItem {
  q: string;
  a: string;
}

const items: FaqItem[] = [
  {
    q: '人人影院是否需要注册才能观看？',
    a: '完全不需要注册。人人影院所有影视资源均可直接在线观看，无需登录、无需付费，打开网站即可畅享海量高清内容。',
  },
  {
    q: '影片播放画质如何？支持哪些清晰度？',
    a: '平台提供最高1080P全高清画质，部分热门影片支持4K超清选项。系统会根据您的网络环境智能调节码率，确保流畅播放不缓冲。',
  },
  {
    q: '新片和剧集更新速度快吗？',
    a: '编辑团队每日同步更新最新内容。院线大片下映后最快一周内上线，热门电视剧同步卫视更新，海外剧集同步字幕组第一时间翻译上线。',
  },
  {
    q: '支持哪些设备和浏览器？',
    a: '人人影院兼容所有主流设备和浏览器，包括电脑、平板、手机。推荐使用Chrome或Safari浏览器获得最佳观看体验，也支持投屏到智能电视。',
  },
  {
    q: '遇到播放问题该怎么办？',
    a: '如遇播放卡顿，可尝试切换备用线路或降低清晰度。若问题持续存在，可通过页面底部联系方式向我们反馈，技术团队会尽快修复。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">常见问题</h2>
            <p className="text-sm text-foreground-600 mt-1">关于人人影院的常见疑问解答</p>
          </div>

          <div className="space-y-4">
            {items.map((item, i) => (
              <div
                key={i}
                className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60"
              >
                <div className="flex items-start gap-3">
                  <span className="shrink-0 w-7 h-7 flex items-center justify-center rounded-lg bg-primary-500/15 text-primary-500 text-sm font-bold mt-0.5">
                    {i + 1}
                  </span>
                  <div>
                    <h3 className="font-medium text-foreground-950 mb-2">{item.q}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}